import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Checkbox from "react-custom-checkbox";
import cx from 'classnames';


const CustomCheckbox = ({ name, value, onChange, checked, className, label, containerClassName, disabled, labelClassName }) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setIsChecked(checked === true);
  }, [checked]);

  const handleOnChange = () => {
    setIsChecked(!isChecked);
    return !isChecked;
  };

  return (
    <Checkbox
      className={className}
      icon={<span className='checkBoxChecked' />}
      increaseArea="20%"
      checked={checked}
      name={name}
      value={value}
      label={label}
      labelStyle={{ margin: 0 }}
      containerClassName={cx(disabled && 'disabledCheckBox', containerClassName)}
      onChange={() => onChange(handleOnChange())}
      disabled={disabled}
      labelClassName={labelClassName}
    />
  );
};

CustomCheckbox.propTypes = {
  name: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.any,
};

CustomCheckbox.defaultProps = {
  className: 'icheckbox_minimal-blue'
};

export default CustomCheckbox;